// extracted by css-extract-rspack-plugin
export default {"container":"CodeMirrorDiff-module__container__Uz2ZF","newFile":"CodeMirrorDiff-module__newFile__re1Ch","deletedFile":"CodeMirrorDiff-module__deletedFile__lrATa"};